import classNames from 'classnames';
import type { FC } from 'react';
import { memo, useMemo } from 'react';

import { ReactComponent as IconMedalBronze } from '../../icons/icon-medal-bronze.svg';
import { ReactComponent as IconMedalGold } from '../../icons/icon-medal-gold.svg';
import { ReactComponent as IconMedalSilver } from '../../icons/icon-medal-silver.svg';
import type { Profile, Reward } from '../../types/api';
import { rewardTypeTextClassnames } from '../Rewards/Rewards';

const rewardColor = (type: keyof typeof rewardTypeTextClassnames) => {
  switch (type) {
    case 'copper':
      return 'text-yellow-400';
    case 'silver':
      return 'text-gray-300';
    case 'gold':
      return 'text-yellow-250';
    default:
      return 'text-gray-600';
  }
};

/**
 *
 * @param rewards
 * @param type
 * @param marginTop
 * @constructor
 */
export const RewardCounter = ({
  rewards,
  type,
  marginTop,
}: {
  rewards: Reward[];
  type: keyof typeof rewardTypeTextClassnames;
  marginTop?: string | number;
}) => {
  const activeRewardCounter = useMemo(
    () => rewards.filter(elt => elt.type === type).length,
    [rewards, type],
  );

  return (
    <div
      style={{ marginTop }}
      className={classNames(rewardTypeTextClassnames[type], 'flex flex-col gap-y-1 text-center')}
    >
      {(type === 'copper' && <IconMedalBronze className="h-4 w-4" />) ||
        (type === 'silver' && <IconMedalSilver className="h-4 w-4" />) ||
        (type === 'gold' && <IconMedalGold className="h-4 w-4" />)}
      <span className={classNames('text-[14px]', rewardColor(type))}>{activeRewardCounter}</span>
    </div>
  );
};

interface Props {
  profile: Profile;
  className?: string;
}

export const ProfilePodiumRewards: FC<Props> = memo(function ProfilePodiumRewards(props) {
  const { profile, className } = props;
  const rewards = profile?.meta?.rewards ?? [];
  return (
    <div className={classNames('w-full max-w-16 flex justify-between text-base', className)}>
      <RewardCounter marginTop="10px" rewards={rewards as Reward[]} type="silver" />
      <RewardCounter marginTop={0} rewards={rewards as Reward[]} type="gold" />
      <RewardCounter marginTop="10px" rewards={rewards as Reward[]} type="copper" />
    </div>
  );
});
